import { AnyAction } from "@reduxjs/toolkit";
import { ThunkAction } from "redux-thunk";
import * as AT from "./actionTypes";
import { RootState } from "../../../../models";
import { PickupPointState } from "../../../../models/state";
import * as Ajax from "../../app/Ajax";
import { API_URL_FETCH_PICKUP_POINTS_FOR_ZIP_CODE } from "../api";

export const fetchPickupPoints =
    (postcode: string): ThunkAction<Promise<PickupPointState>, RootState, unknown, AnyAction> =>
    (dispatch) => {
        const response: Promise<PickupPointState> = Ajax.get(
            { url: API_URL_FETCH_PICKUP_POINTS_FOR_ZIP_CODE(postcode) },
            dispatch,
        );

        dispatch({
            type: AT.PICKUP_POINTS_FETCH_PICKUP_POINTS,
            payload: response,
        });

        return response;
    };
